export const environment = {
  production: true,
  redirectUri: '%%REDIRECT_URI%%',
  crossDomainCookieURL: '%%CROSS_DOMAIN_COOKIE_URL%%',
  showEnvConfigTool: '%%SHOW_ENV_CONFIG_TOOL%%',
  showMyProfile: '%%SHOW_MY_PROFILE%%',
  sessionTimeoutInMinutes: 15,
  lastActivityCookieWriteInSeconds: 1,
  enableSLAutoProvisioning: '%%ENABLE_SL_AUTOPROVISIONING%%',
  adminToolServiceUrl: '%%ADMIN_TOOL_SERVICE_URL%%',
  useLegacyAPI: null,
  loginServiceUrl: '%%LOGIN_SERVICE_URL%%',
  appswitcherUrl: '%%APPLICATION_SWITCHER_URL%%',
  storage: 'localStorage',
  employeeIdEnabled: true,
  environmentName: '%%$STACK%%',
  loginUrl: '%%LOGIN_URL%%'

}

